import React, { useState, useEffect } from 'react';
import SportsScheduleTable from './components/SportsScheduleTable';
import Login from './components/Login';
import UsersManagement from './components/UsersManagement';
import EventAuditPage from './components/EventAuditPage';
import ProfilePage from './components/ProfilePage';
import DebugPanel from './components/DebugPanel';
import './App.css';

// Релиз: дебаг-панель только при REACT_APP_DEBUG=true (для разработки)
const SHOW_DEBUG = process.env.REACT_APP_DEBUG === 'true';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showUsersManagement, setShowUsersManagement] = useState(false);
  const [showEventAudit, setShowEventAudit] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [focusedEventId, setFocusedEventId] = useState(null);
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || 'user');

  useEffect(() => {
    // Проверяем наличие токена при загрузке
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
      // Обновляем роль из localStorage
      const role = localStorage.getItem('userRole') || 'user';
      setUserRole(role);
    }
    setLoading(false);
  }, []);

  // Слушаем изменения в localStorage для обновления роли
  useEffect(() => {
    const handleStorageChange = () => {
      const role = localStorage.getItem('userRole') || 'user';
      setUserRole(role);
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    // Обновляем роль после логина
    const role = localStorage.getItem('userRole') || 'user';
    setUserRole(role);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    setIsAuthenticated(false);
    setUserRole('user');
  };

  if (loading) {
    return <div className="App">Загрузка...</div>;
  }

  if (!isAuthenticated) {
    return (
      <div className="App">
            <Login onLogin={handleLogin} />
      </div>
    );
  }

  return (
    <div className="App">
      <div className="app-header">
        <h1 className="app-title">Календарь спортивных мероприятий</h1>
        <div className="app-header-actions">
          <button
            onClick={() => setShowProfile(true)}
            className="users-management-btn"
          >
            Профиль
          </button>
          {userRole === 'superuser' && (
            <>
              <button
                onClick={() => setShowUsersManagement(true)}
                className="users-management-btn"
              >
                Управление пользователями
              </button>
            </>
          )}
          {(userRole === 'admin' || userRole === 'superuser') && (
            <>
              <button
                onClick={() => setShowEventAudit(true)}
                className="users-management-btn"
              >
                Журнал мероприятий
              </button>
            </>
          )}
          <button
            onClick={handleLogout}
            className="logout-btn"
          >
            Выйти
          </button>
        </div>
      </div>
      {showEventAudit ? (
        <EventAuditPage
          onBack={() => setShowEventAudit(false)}
          onEventSelect={(eventId) => {
            setFocusedEventId(eventId);
            setShowEventAudit(false);
          }}
        />
      ) : showProfile ? (
        <ProfilePage onBack={() => setShowProfile(false)} />
      ) : (
        <SportsScheduleTable
          focusedEventId={focusedEventId}
          onFocusCleared={() => setFocusedEventId(null)}
        />
      )}
      {showUsersManagement && (
        <UsersManagement onClose={() => setShowUsersManagement(false)} />
      )}
      {SHOW_DEBUG && <DebugPanel />}
    </div>
  );
}

export default App;
